import { GetStoreStrategy } from "@/services/store.service";

export const getDiscriminator = <
    TStrategy extends GetStoreStrategy,
    TSku extends string | undefined
>({
    strategy,
    sku
}: {
    strategy: TStrategy;
    sku?: TSku;
}) => {
    return sku ? (`${strategy}_${sku}` as const) : (`${strategy}` as const);
};
